import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import fontColor from '../fontColor';

/**
 * พรีวิว 2 สไลด์ของหน้าเว็บลงทะเบียน (สไลด์ 1 = ฟอร์มกรอกข้อมูล, สไลด์ 2 = ตรวจสอบข้อมูล)
 * เดิม JSX ก้อนนี้ (~350 บรรทัด) ซ้ำกันเป๊ะทั้งใน CreatePortal.jsx และ EditPortal.jsx
 *
 * แก้ bug ที่พบระหว่าง refactor: EditPortal.jsx เดิมเขียน
 * `border: '1px solid portalthemesecondcolor'` เป็น string ตรง ๆ ไม่ได้ interpolate
 * ตัวแปรสี (CreatePortal.jsx เขียนถูกด้วย backtick) ทำให้กรอบปุ่ม "ดำเนินการต่อ" ใน
 * preview ของ Edit ไม่เปลี่ยนสีตามธีม — ที่นี่ใช้เวอร์ชันที่ interpolate ถูกต้อง
 */
const ThemePreviewCard = ({
    slidePage,
    setSlidePage,
    primaryColor,
    secondaryColor,
    logoSrc,
    slide1NavTop = '85%', // EditPortal ใช้ 85%, CreatePortal ใช้ 86% เดิม — ระบุตอนเรียกใช้
}) => {
    const goPrev = () => setSlidePage(slidePage > 1 ? slidePage - 1 : 1);
    const goNext = () => setSlidePage(slidePage < 2 ? slidePage + 1 : 2);

    const gradientLayers = (
        <>
            <div
                style={{
                    position: 'absolute',
                    width: '762.17px',
                    height: '492.28px',
                    left: '35%',
                    top: '20%',
                    background: `linear-gradient(190.29deg, ${primaryColor} 7.68%, ${secondaryColor} 95.33%)`,
                    borderRadius: '8px',
                    transform: 'matrix(0.54, -0.84, 0.92, 0.39, 0, 0)',
                    zIndex: '1',
                }}
            />
            <div
                style={{
                    position: 'absolute',
                    width: '762.17px',
                    height: '492.28px',
                    left: '20%',
                    top: '20%',
                    opacity: '50%',
                    background: `linear-gradient(180deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
                    borderRadius: '8px',
                    transform: 'matrix(0.54, -0.84, 0.92, 0.39, 0, 0)',
                    zIndex: '0',
                }}
            />
            <img
                src="/img/Character with laptop in cafe 3.png"
                alt="imgsettheme"
                style={{ position: 'absolute', top: '65%', left: '50%', zIndex: '1' }}
            />
        </>
    );

    const navControls = (topOverride) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div
                style={{
                    position: 'absolute',
                    width: '146px',
                    height: '36px',
                    backgroundColor: '#000000B2',
                    border: 'none',
                    borderRadius: '16px',
                    textAlign: 'center',
                    padding: '5px',
                    fontFamily: 'Sarabun',
                    fontWeight: '500',
                    fontSize: '14px',
                    color: 'white',
                    ...(topOverride ? { top: topOverride } : {}),
                }}
            >
                <ArrowBackIosIcon
                    onClick={goPrev}
                    style={{ width: '15px', height: '15px', color: 'white', marginRight: '5px', cursor: 'pointer' }}
                />
                {slidePage} / 2
                <ArrowForwardIosIcon
                    onClick={goNext}
                    style={{ width: '15px', height: '15px', color: 'white', marginLeft: '5px', cursor: 'pointer' }}
                />
            </div>
        </div>
    );

    return (
        <div
            style={{
                width: '90%',
                maxWidth: '598px',
                height: '504px',
                backgroundColor: 'white',
                borderRadius: '8px',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            {gradientLayers}
            {slidePage === 1 ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div
                        style={{
                            width: '334px',
                            height: '414px',
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            marginTop: '35px',
                            boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.25)',
                            zIndex: '1',
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            {logoSrc ? (
                                <img
                                    src={logoSrc}
                                    alt="img"
                                    style={{ maxHeight: '70px', maxWidth: '65.54px', marginTop: '30px' }}
                                />
                            ) : (
                                <div style={{ position: 'relative' }}>
                                    <div
                                        style={{
                                            top: '16px',
                                            right: '-15px',
                                            position: 'absolute',
                                            width: '64px',
                                            height: '64px',
                                            borderRadius: '100px',
                                            border: '2px #C7C7C7 solid',
                                        }}
                                    />
                                    <InsertPhotoIcon
                                        style={{
                                            color: '#C7C7C7',
                                            marginTop: '30px',
                                            width: '35px',
                                            height: '35px',
                                            marginBottom: '15px',
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                        <div style={{ fontSize: '12px', marginTop: '20px', marginLeft: '32px' }}>ยินดีต้อนรับ</div>
                        <div style={{ marginLeft: '32px', fontSize: '10px', marginTop: '20px', marginBottom: '10px' }}>
                            กรุณายืนยันตัวตนเพื่อเข้าใช้งาน
                        </div>
                        <span style={{ fontSize: '10px', marginLeft: '32px' }}>เลขบัตรประชาชน</span>
                        <div
                            style={{
                                border: '1px solid #EEEEEE',
                                borderRadius: '6px',
                                width: '274px',
                                height: '36px',
                                marginLeft: '32px',
                                marginTop: '5px',
                                marginBottom: '16px',
                            }}
                        />
                        <span style={{ fontSize: '10px', marginTop: '20px', marginLeft: '32px' }}>หมายเลขโทรศัพท์</span>
                        <div
                            style={{
                                border: '1px solid #EEEEEE',
                                borderRadius: '6px',
                                width: '274px',
                                height: '36px',
                                marginLeft: '32px',
                                marginTop: '5px',
                            }}
                        />
                        <div
                            style={{
                                border: `1px solid ${secondaryColor}`,
                                borderRadius: '4px',
                                width: '274px',
                                height: '32px',
                                marginLeft: '32px',
                                fontSize: '10px',
                                padding: '5px',
                                color: fontColor(secondaryColor),
                                backgroundColor: secondaryColor,
                                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
                                marginTop: '34px',
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            ดำเนินการต่อ
                        </div>
                        {navControls(slide1NavTop)}
                    </div>
                </div>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div
                        style={{
                            width: '334px',
                            height: '414px',
                            backgroundColor: 'white',
                            marginTop: '40px',
                            borderRadius: '16px',
                            boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.25)',
                            zIndex: '2',
                        }}
                    >
                        <div
                            style={{
                                fontFamily: 'Sarabun',
                                fontStyle: 'normal',
                                fontWeight: '600',
                                fontSize: '14px',
                                marginLeft: '25px',
                                marginTop: '20px',
                            }}
                        >
                            ตรวจสอบข้อมูล
                        </div>
                        <div style={{ width: '271px', height: '67px', margin: '5px', padding: '5px' }}>
                            <div
                                style={{
                                    fontFamily: 'Sarabun',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    fontSize: '10px',
                                    marginBottom: '12px',
                                    marginLeft: '15px',
                                    color: secondaryColor,
                                }}
                            >
                                ข้อมูลส่วนบุคคล
                            </div>
                            <div
                                className="row"
                                style={{ marginLeft: '10px', fontSize: 10, fontFamily: 'Sarabun', fontWeight: 400, zoom: 0.65 }}
                            >
                                <div className="col">
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>เลขบัตรประชาชน :</div>
                                    <div style={{ marginBottom: '6px' }}>1209800908090</div>
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>คำนำหน้าชื่อ :</div>
                                    <div style={{ marginBottom: '6px' }}>นางสาว</div>
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>Title Name :</div>
                                    <div style={{ marginBottom: '4px' }}>Ms.</div>
                                </div>
                                <div className="col">
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>วัน / เดือน / ปีเกิด :</div>
                                    <div style={{ marginBottom: '6px' }}>10/04/96</div>
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>ชื่อ :</div>
                                    <div style={{ marginBottom: '6px' }}>พรรณวดี</div>
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>Name :</div>
                                    <div style={{ marginBottom: '4px' }}>Phannavadee</div>
                                </div>
                                <div className="col">
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>เพศ :</div>
                                    <div style={{ marginBottom: '6px' }}>หญิง</div>
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>นามสกุล :</div>
                                    <div style={{ marginBottom: '6px' }}>แก้วพิชัย</div>
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>Last Name :</div>
                                    <div style={{ marginBottom: '4px' }}>Keawpichai</div>
                                </div>
                            </div>
                            <div style={{ border: '1px solid #EEEEEE', marginTop: '5px', marginLeft: '15px' }} />
                        </div>
                        <div style={{ width: '271px', height: '67px', margin: '5px', marginTop: '40px', padding: '5px' }}>
                            <div
                                style={{
                                    fontFamily: 'Sarabun',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    fontSize: '10px',
                                    marginTop: '10px',
                                    marginBottom: '7px',
                                    marginLeft: '15px',
                                    color: secondaryColor,
                                }}
                            >
                                ที่อยู่
                            </div>
                            <div
                                className="row"
                                style={{ marginLeft: '10px', fontFamily: 'Sarabun', fontWeight: 400, fontSize: 10, zoom: 0.65 }}
                            >
                                <div className="col">
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>บ้านเลขที่ :</div>
                                    <div style={{ marginBottom: '6px' }}>111</div>
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>ซอย :</div>
                                    <div style={{ marginBottom: '6px' }}>-</div>
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>จังหวัด :</div>
                                    <div style={{ marginBottom: '4px' }}>-</div>
                                </div>
                                <div className="col">
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>ชั้น :</div>
                                    <div style={{ marginBottom: '6px' }}>14</div>
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>ถนน :</div>
                                    <div style={{ marginBottom: '6px' }}>-</div>
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>รหัสไปรษณีย์ :</div>
                                    <div style={{ marginBottom: '4px' }}>-</div>
                                </div>
                                <div className="col">
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>หมู่บ้าน :</div>
                                    <div style={{ marginBottom: '6px' }}>-</div>
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>แขวง(ตำบล) :</div>
                                    <div style={{ marginBottom: '6px' }}>-</div>
                                </div>
                                <div className="col">
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>ตึก :</div>
                                    <div style={{ marginBottom: '6px' }}>-</div>
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>แขวง(ตำบล) :</div>
                                    <div style={{ marginBottom: '6px' }}>-</div>
                                </div>
                            </div>
                            <div style={{ border: '1px solid #EEEEEE', marginLeft: '15px' }} />
                        </div>
                        <div style={{ width: '271px', height: '67px', margin: '5px', marginTop: '40px', padding: '5px' }}>
                            <div
                                style={{
                                    fontFamily: 'Sarabun',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    fontSize: '10px',
                                    marginBottom: '7px',
                                    marginLeft: '15px',
                                    marginTop: '10px',
                                    color: secondaryColor,
                                }}
                            >
                                การศึกษา
                            </div>
                            <div
                                className="row"
                                style={{ fontSize: 10, fontFamily: 'Sarabun', fontWeight: 400, marginLeft: '10px', zoom: 0.65 }}
                            >
                                <div className="col">
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>ระดับการศึกษา :</div>
                                    <div style={{ marginBottom: '6px' }}>ปริญญาตรี</div>
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>สถานะการศึกษา :</div>
                                    <div style={{ marginBottom: '6px' }}>กำลังศึกษา</div>
                                </div>
                                <div className="col">
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>คณะ :</div>
                                    <div style={{ marginBottom: '6px' }}>สารสนเทศศึกษา</div>
                                </div>
                                <div className="col">
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>สาขา / ภาควิชา :</div>
                                    <div style={{ marginBottom: '6px' }}>สารสนเทศศึกษา</div>
                                </div>
                                <div className="col">
                                    <div style={{ color: '#757575', marginBottom: '4px' }}>รหัสนักศึกษา :</div>
                                    <div style={{ marginBottom: '6px' }}>2345333-2</div>
                                </div>
                            </div>
                            <div style={{ border: '1px solid #EEEEEE', marginLeft: '15px', marginTop: '5px' }} />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                marginTop: '30px',
                                flexDirection: 'column',
                                alignContent: 'center',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                fontFamily: 'Sarabun',
                                fontWeight: '500',
                                fontSize: '6px',
                            }}
                        >
                            <button
                                style={{
                                    width: '225px',
                                    height: '18px',
                                    border: `1px solid ${secondaryColor}`,
                                    background: 'white',
                                    borderColor: secondaryColor,
                                    borderRadius: '4px',
                                    zoom: 0.9,
                                }}
                            >
                                แก้ไข
                            </button>
                            <button
                                style={{
                                    width: '225px',
                                    height: '18px',
                                    border: 'none',
                                    backgroundColor: '#EEEEEE',
                                    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
                                    color: 'white',
                                    borderRadius: '4px',
                                    marginTop: '8px',
                                    zoom: 0.9,
                                }}
                            >
                                ดำเนินการต่อ
                            </button>
                        </div>
                        {navControls(null)}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ThemePreviewCard;